
import SETTINGS from 'settings'
import own_version_info from "../version"
import { lang } from 'lang'

//refer https://github.com/englercj/resource-loader/blob/master/src/Loader.js
export function cancelCaching()
{
    if ( ! own_version_info || ! own_version_info.build )
    {
        console.error( "NO BUILD INFORMATION" )
    }
    
    var originalAdd = PIXI.loader.add;
    PIXI.loader.add = function()
    {
        //throughout the project resources are referenced the same way they're loaded so when we alter the URL to cancel caching they can't be referenced anymore (only sole ones - those without json wrappers), but PIXI allows specifying name separately from path so we define our own args:
        const newArgs = Array.prototype.slice.call( arguments );
        switch ( arguments.length )
        {
            case 1:
                const arg = arguments[ 0 ]
                if ( typeof arg === 'string' )
                {
                    newArgs[ 1 ] = trans_url( arg )
                }
                //no need to handle array since I know (it's not defined by API :( ) that PIXI just calls this function again with all the array values one-by-one ...
                else if ( Array.isArray( arg ) ) {}
                else
                {
                    //multi language resource:
                    if ( arg.name ) {
                        
                        //if specified to load only specific language:
                        if ( arg.only ) {
                            if ( ! arg.only.includes( lang() ) ) return this;
                            newArgs[ 0 ] = arg.name
                            newArgs[ 1 ] = trans_url( arg.name )
                        }
                        else {
                            newArgs[ 0 ] = arg.name
                            
                            //if resource specified for current language:
                            if ( arg[ lang() ] ) {
                                const i = arg.name.lastIndexOf( '.' )
                                if ( i < 0 ) console.error( 'Wrong resource name:', arg.name )
                                newArgs[ 1 ] = trans_url( arg.name.substring( 0, i ) + '.' + lang() + arg.name.substring( i ) )
                                console.log( 'LANG:', arg, '->', newArgs[ 1 ] )
                            }
                            //[original] default resource for current language:
                            else {
                                newArgs[ 1 ] = trans_url( arg.name )
                            }
                        }
                    }
                    //our custom animation batch:
                    else {
                        const arr = []
                        for ( let i = 0; i < arg.count; ++ i )
                        {
                            arr.push( arg.path.$( i ) )
                        }
                        newArgs[ 0 ] = arr
                        console.log( 'custom to', arg )
                    }
                }
                break;
            
            //that's how font loads it's atlas:
            /**
            * @variation 4
            * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
            * @param {IAddOptions} [options] - The options for the load.
            * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
            */
            case 3:
                newArgs[ 0 ] = trans_url( arguments[ 0 ] )
                break

            //that's how PIXI loads resources parsed out from .json files:
            case 4:
                newArgs[ 1 ] = trans_url( arguments[ 1 ] );
                break;

            default:
                console.warn( 'PIXI: Unknown resources load spec.', arguments );
                break;
        }
        
        let r
        //mute 'resource named ... already exists ...' error:
        try{r = originalAdd.apply( PIXI.loader, newArgs )}catch(e){console.warn(e.message)};
        return r
    };
}

let url_settings

export function need_reformat( URL )
{
    if ( SETTINGS.preserve_resource_format_for_all ) return false

    //все интерфейсы пусть без сжатия:
    if (
        ( URL.indexOf( '800' ) >= 0 && URL.indexOf( '600' ) >= 0 )
        ||
        ( URL.indexOf( '1024' ) >= 0 && URL.indexOf( '768' ) >= 0 )
    )
    {
        return false
    }

    return ! SETTINGS.preserve_resource_format.some( f => URL.indexOf( f ) >= 0 || f.indexOf( URL ) >= 0 )
}

/** Cancel URL caching, redirect common resources and determin resources type.*/
export function trans_url( URL )
{
    //resources redirection based on OS/browser:
    if ( need_reformat( URL ) )
    {
        if ( ! url_settings )
        {
            url_settings = {}
            
            //if Chrome browser:
            if ( /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) )
            {
                url_settings.webp = true
                //Chrome webp doesn't work on iOS:
                if ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) )
                {
                    url_settings.webp = false
                }
            }
            //if Safari browser:
            else if ( !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) )
            {
                url_settings.jp2 = true
            }
        }
        
        if ( url_settings.webp )
        {
            if ( URL.endsWith( '.png' ) )
            {
                URL = URL.substring( 0, URL.length - 3 ) + 'webp'
            }
        }
        else if ( url_settings.jp2 )
        {
            if ( URL.endsWith( '.png' ) )
            {
                URL = URL.substring( 0, URL.length - 3 ) + 'jp2'
            }
        }
    }
    else {
        if ( ! SETTINGS.preserve_resource_format_for_all ) console.log( 'resource', URL, 'set to NOT reformat' )
    }
    
    
    if ( URL.indexOf( '?' ) >= 0 ) return URL
    
    const normal_cache = own_version_info ? encodeURI( own_version_info.build ) : ( new Date() ).getTime()
    
    
    //ресурсы из pixi json файлов уже имеют нужный путь:
    if ( URL.startsWith( common_path() ) )
    {
        return URL + '?' + common_cache
    }
    
    const t = 'res/common/'
    if ( URL.indexOf( t ) == 0 )
    {
        return common_path() + URL.substring( t.length ) + '?' + common_cache
    }
    
    return URL + '?' + normal_cache
}






// WEBPACK FOOTER //
// ./src/library/res.es6